// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1935) return "static/chunks/1935-90cb53299d3bcb7e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"294":"830d8df2b4b685a0","1101":"3bf41876e66d6c57","4933":"a0b86759eb4a47db","8901":"a36e09ae1e14855d"}[chunkId] + ".js";
};